import React from "react";
import { Modal, Form, Input, Button } from "antd";
import { postReq } from "../api";

export default function CreateSpocModal({
  open,
  onClose,
  companyId,
  onSuccess,
}) {
  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    const payload = {
      companyId,
      name: values.name,
      email: values.email,
      designation: values.designation,
      linkedinUrl: values.linkedinUrl,
      source: "manual",
    };

    await postReq("/common/create_spoc", payload);

    form.resetFields();
    onClose();
    onSuccess && onSuccess();
  };

  return (
    <Modal
      open={open}
      title="Add SPOC"
      onCancel={onClose}
      footer={null}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: "Name is required" }]}
        >
          <Input placeholder="Enter full name" />
        </Form.Item>

        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: "Email is required" },
            { type: "email", message: "Enter a valid email" },
          ]}
        >
          <Input placeholder="Enter email address" />
        </Form.Item>

        <Form.Item
          name="designation"
          label="Designation"
          rules={[{ required: true, message: "Designation is required" }]}
        >
          <Input placeholder="e.g. HR Manager, CTO" />
        </Form.Item>

        <Form.Item
          name="linkedinUrl"
          label="LinkedIn URL"
          rules={[
            {
              type: "url",
              message: "Enter a valid LinkedIn URL",
            },
          ]}
        >
          <Input placeholder="https://www.linkedin.com/in/username" />
        </Form.Item>

        <Button type="primary" htmlType="submit" block>
          Create SPOC
        </Button>
      </Form>
    </Modal>
  );
}
